import { css } from '@landr/styled-system/css';

export const defaultRowContainer = css({
    display: 'flex',
    alignItems: 'center',
    minHeight: 'sm',
    height: 'sm',
    boxSizing: 'border-box',
});

export const playerButton = css({
    width: 'sm',
});

export const playerWaveform = css({
    maxWidth: '220px',
    width: 'full',
    height: 'full',
});

export const playerDuration = css({
    width: 'xs',
});
